import { AuthLayout } from '../components/AuthLayout/AuthLayout';
import { ResetPasswordForm } from '../components/password/ResetPasswordForm';

export const ResetPasswordPage = () => {
  return (
    <AuthLayout>
      <ResetPasswordForm />
    </AuthLayout>
  );
};
